export const DocumentAnalysisProofOfAddressDocumentTypesEnum = {
  energy_bill: 'energy_bill',
  telco_bill: 'telco_bill',
  official_document: 'official_document',
  // Fallback
  other: 'other',
} as const;
export type DocumentAnalysisProofOfAddressDocumentTypesEnum =
  (typeof DocumentAnalysisProofOfAddressDocumentTypesEnum)[keyof typeof DocumentAnalysisProofOfAddressDocumentTypesEnum];
